import { ALinkStandaloneSize } from '../../atoms/ALinkStandalone/index';
import { ABodySize, ABodyColor } from '../../atoms/ABody/index';

export enum MParagraphAlignment {
  Center = 'Center',
  Left = 'Left',
}
export interface MParagraphProps {
  alignment?: MParagraphAlignment;
  truncated?: boolean;
  truncateLines?: number;
  expanded?: boolean;
  bodySize?: ABodySize;
  bodyColor?: ABodyColor;
  truncationLinkSize?: ALinkStandaloneSize;
  children?: string;
  className?: string;
}
